import { Outlet } from 'react-router';

import Header from '@/components/header';

function SharedLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
    </>
  );
}

export default SharedLayout;
